import React from 'react';
import type { WizardStepKey, WizardStep } from './types';
import '../Onboarding/WizardStepper.scss';

interface WizardStepperProps {
  steps: WizardStep[];
  currentStep: WizardStepKey;
  completedSteps: WizardStepKey[];
  onStepClick?: (step: WizardStepKey) => void;
}

const WizardStepper: React.FC<WizardStepperProps> = ({
  steps,
  currentStep,
  completedSteps,
  onStepClick,
}) => {
  const isStepCompleted = (stepKey: WizardStepKey) => {
    return completedSteps.includes(stepKey);
  };

  const isStepActive = (stepKey: WizardStepKey) => {
    return currentStep === stepKey;
  };

  const handleStepClick = (stepKey: WizardStepKey) => {
    if (onStepClick) {
      onStepClick(stepKey);
    }
  };

  return (
    <div className="wizard-stepper">
      <div className="stepper-track">
        {steps.map((step, index) => {
          const isCompleted = isStepCompleted(step.key);
          const isActive = isStepActive(step.key);
          const isConnectorCompleted = isCompleted;

          return (
            <React.Fragment key={step.key}>
              <div
                className={`stepper-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${!isActive && !isCompleted ? 'pending' : ''}`}
                onClick={() => handleStepClick(step.key)}
              >
                <div className="step-indicator">
                  {isCompleted ? (
                    <i className="bx bx-check"></i>
                  ) : (
                    <span className="step-number">{step.order}</span>
                  )}
                </div>
                <div className="step-content">
                  <div className="step-title">{step.title}</div>
                  <div className="step-description">{step.description}</div>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`stepper-connector ${isConnectorCompleted ? 'completed' : ''}`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default WizardStepper;

